
import { useQuery } from '@tanstack/react-query';
import { getBatches, InvoiceBatch } from '@/services/batchService';

export function useBatchList() {
  const { data: batches = [], isLoading, error } = useQuery({
    queryKey: ['invoice-batches'],
    queryFn: getBatches
  });

  return {
    batches,
    isLoading,
    error
  };
}
